const config = {
  site: {
    name: "Ellyma Bertaqwa",
    github: "https://ellymabeauty.com",
  },
};

export default config;
